var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7614_1304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5 21.75C43.5 9.73781 33.7622 0 21.75 0C9.73781 0 0 9.73781 0 21.75C0 33.7622 9.73781 43.5 21.75 43.5C33.7622 43.5 43.5 33.7622 43.5 21.75Z",
    fill: "url(#paint0_linear_7614_1304)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 39C31.2769 39 39 31.2769 39 21.75C39 12.2231 31.2769 4.5 21.75 4.5C12.2231 4.5 4.5 12.2231 4.5 21.75C4.5 31.2769 12.2231 39 21.75 39Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9531 32.6445V30.2891C19.9141 30.2656 18.9844 30.168 18.1641 29.9961C17.3516 29.8164 16.6094 29.5781 15.9375 29.2812V26.1875C16.6016 26.5078 17.3945 26.8008 18.3164 27.0664C19.2383 27.3242 20.1172 27.4805 20.9531 27.5352V23.9023C19.7188 23.418 18.7305 22.9492 17.9883 22.4961C17.2539 22.0352 16.7227 21.5273 16.3945 20.9727C16.0742 20.4102 15.9141 19.7383 15.9141 18.957C15.9141 18.1602 16.125 17.4727 16.5469 16.8945C16.9766 16.3086 17.5703 15.8398 18.3281 15.4883C19.0859 15.1367 19.9609 14.918 20.9531 14.832V13.0391H22.5586V14.7852C23.4648 14.8164 24.3086 14.9219 25.0898 15.1016C25.8789 15.2734 26.6523 15.5273 27.4102 15.8633L26.3086 18.6055C25.668 18.3398 25.0234 18.1328 24.375 17.9844C23.7344 17.8359 23.1289 17.7383 22.5586 17.6914V21.1484C23.4258 21.4688 24.25 21.8164 25.0312 22.1914C25.8125 22.5664 26.4492 23.043 26.9414 23.6211C27.4336 24.1992 27.6797 24.957 27.6797 25.8945C27.6797 27.0586 27.2539 28.0352 26.4023 28.8242C25.5586 29.6133 24.2773 30.0859 22.5586 30.2422V32.6445H20.9531ZM22.5586 27.4531C23.1055 27.3594 23.5078 27.1992 23.7656 26.9727C24.0234 26.7383 24.1523 26.4375 24.1523 26.0703C24.1523 25.8516 24.0938 25.6562 23.9766 25.4844C23.8594 25.3125 23.6797 25.1523 23.4375 25.0039C23.2031 24.8477 22.9102 24.6914 22.5586 24.5352V27.4531ZM20.9531 20.4922V17.7383C20.6328 17.7852 20.3594 17.8633 20.1328 17.9727C19.9062 18.0742 19.7344 18.207 19.6172 18.3711C19.5 18.5352 19.4414 18.7305 19.4414 18.957C19.4414 19.1836 19.4922 19.3828 19.5938 19.5547C19.7031 19.7266 19.8672 19.8867 20.0859 20.0352C20.3125 20.1836 20.6016 20.3359 20.9531 20.4922Z",
    fill: "#ABABAB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7614_1304",
    x1: -5.25,
    y1: 21,
    x2: 53.25,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462301,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7614_1304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.5cfef0c13155cdce45d73bbd16f2f50b.svg";
export { ForwardRef as ReactComponent };